import vue from 'vue'

const trackEvent = ( label ) => {
    if(process.env.VUE_APP_MODE != 'development'){
        gtag('event', 'click', { 'event_category': process.env.VUE_APP_TRACLEVENT_NAME, 'event_label': label });
    }else{
        console.log(process.env.VUE_APP_TRACLEVENT_NAME + ', ' + label);
    }
}

function regTrackEvent (){
    vue.prototype.$trackEvent = trackEvent
}
export default regTrackEvent